import React from 'react'
import { StyleSheet } from 'react-native'
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors'
import {
  DNABox,
  DNAText,
  DNAButton,
  Iffy,
} from '@alucio/lux-ui'
import SvgFileAccountOutline from 'src/assets/icons/FileAccountOutline'
import SvgListBoxOutline from 'src/assets/icons/ListBoxOutline'
import SvgLightbulbOn20 from 'src/assets/icons/LightbulbOn20'
import { useHubsState } from 'src/state/context/Hubs/HubsStateProvider'
import { DNAModalActions } from 'src/state/redux/slice/DNAModal/DNAModal'
import { useDispatch } from 'react-redux'
import DNASelectTemplateModal from '../Modal/DNASelectTemplateModal'
import { useHubTemplatesList } from 'src/state/redux/selector/hub'
import useFeatureFlags from 'src/hooks/useFeatureFlags/useFeatureFlags'

const styles = StyleSheet.create({
  emptyStateContainer: {
    minHeight: 'calc(100vh - 280px)',
    padding: 30,
  },
  subTitle: {
    width: 560,
    textAlign: 'center',
  },
  cardContainer: {
    padding: 32,
    maxWidth: 350,
    borderColor: colors['color-gray-100'],
    borderWidth: 1,
    borderRadius: 12,
    marginVertical: 25,
  },
  cardText: {
    lineHeight: 25,
  },
})

const HubEmptyState = () => {
  const { handleCreateHubs, handleCreateTemplateInstance } = useHubsState()
  const dispatch = useDispatch()
  const hubTemplatesORM = useHubTemplatesList()
  const isHubTemplatesEnabled = useFeatureFlags('BEAC_6094_hubs_templates')
  const hideCreateHub = useFeatureFlags('BEAC_7952_hide_create_hub')

  const createTemplateInstance = () => {
    dispatch(DNAModalActions.setModal({
      isVisible: true,
      allowBackdropCancel: true,
      component: (modalProps) => (
        <DNASelectTemplateModal
          {...modalProps}
          hubTemplatesORM={hubTemplatesORM}
          handleCreateTemplateInstance={handleCreateTemplateInstance}
          handleCreateHubs={handleCreateHubs}
        />
      ),
    }))
  }

  return (
    <DNABox
      fill
      appearance="col"
      spacing="md"
      alignX="center"
      alignY="center"
      style={styles.emptyStateContainer}
    >
      <DNAText testID="hub-empty-state-text" h2 bold>What are Hubs?</DNAText>
      <DNAText h3 bold={false} status="subtle" style={ styles.subTitle }>
        Hubs can be used to share content in meeting follow-ups and
        can be created for a single recipient or multiple recipients.
      </DNAText>
      <DNABox fill spacing="md" childFill>
        <DNABox fill appearance="col" spacing="md" style={ styles.cardContainer }>
          <SvgFileAccountOutline />
          <DNAText h4>Share content with your audience</DNAText>
          <DNAText b1 status="subtle" style={ styles.cardText }>
            Select documents and journal links of interest to share with your target audience.
          </DNAText>
        </DNABox>
        <DNABox fill appearance="col" spacing="md" style={ styles.cardContainer }>
          <SvgListBoxOutline />
          <DNAText h4>Create action items</DNAText>
          <DNAText b1 status="subtle" style={ styles.cardText }>
            You and your audience can create to-do lists to work towards common goals.
          </DNAText>
        </DNABox>
        <DNABox fill appearance="col" spacing="md" style={ styles.cardContainer }>
          <SvgLightbulbOn20 />
          <DNAText h4>Get insights from audience activity</DNAText>
          <DNAText b1 status="subtle" style={ styles.cardText }>
            Gain insights to which content your audience engaged with most.
          </DNAText>
        </DNABox>
      </DNABox>
      <DNABox appearance="row" spacing="md" alignX="center">
        <Iffy is={!hideCreateHub}>
          <DNAButton
            testID="hub-empty-state-create-hub-btn"
            appearance="outline"
            size="lg"
            onPress={handleCreateHubs}
          >
            Create hub
          </DNAButton>
        </Iffy>
        <Iffy is={isHubTemplatesEnabled}>
          <DNAButton
            testID="hub-empty-state-create-hub-from-template-btn"
            size="lg"
            onPress={createTemplateInstance}
          >
            Create from template
          </DNAButton>
        </Iffy>
      </DNABox>
    </DNABox>
  )
}

export default HubEmptyState
